const baseRoute = 'total-energies-risk/:moduleBridgeHex/';
export default {
  user_module_totalEnergiesRisk_base: {
    path: baseRoute,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_totalEnergiesRisk_risk_list: {
    path: `${baseRoute}risk/list/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_totalEnergiesRisk_risk_add: {
    path: `${baseRoute}risk/add/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_totalEnergiesRisk_risk_edit: {
    path: `${baseRoute}risk/edit/:riskHex/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      riskHex: 0,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_totalEnergiesRisk_control_list: {
    path: `${baseRoute}control/list/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_totalEnergiesRisk_control_add: {
    path: `${baseRoute}control/add/:riskID/`,
    parameters: {
      moduleBridgeHex: undefined,
      riskID: 0,
    },
  },
  user_module_totalEnergiesRisk_control_edit: {
    path: `${baseRoute}control/edit/:controlHex/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      controlHex: 0,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_totalEnergiesRisk_control_review_edit: {
    path: `${baseRoute}control/review/edit/:reviewHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      reviewHex: 0,
    },
  },
  user_module_totalEnergiesRisk_actionPlan_list: {
    path: `${baseRoute}action-plan/list/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_totalEnergiesRisk_actionPlan_add: {
    path: `${baseRoute}action-plan/add/:riskID/`,
    parameters: {
      moduleBridgeHex: undefined,
      riskID: 0,
    },
  },
  user_module_totalEnergiesRisk_actionPlan_edit: {
    path: `${baseRoute}action-plan/edit/:actionPlanHex/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      actionPlanHex: 0,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_totalEnergiesRisk_actionPlan_review_edit: {
    path: `${baseRoute}action-plan/review/edit/:reviewHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      reviewHex: 0,
    },
  },
  user_module_totalEnergiesRisk_process_list: {
    path: `${baseRoute}process/list/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_totalEnergiesRisk_log_list: {
    path: `${baseRoute}log/list/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
};
